module.exports = __webpack_public_path__ + "img/40_40.c0258063.png";